import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { gotoNewPage } from '@src/utils';

const Layout = ({ content }) => {

    return (
        <div className={styles.layout}>
            <div className={styles.btn} onClick={gotoNewPage({ url: 'https://wj.qq.com/s2/12954139/3b00/', type: 'web' })} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
